import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=551142c4&"
import script from "./NoData.vue?vue&type=script&lang=js&"
export * from "./NoData.vue?vue&type=script&lang=js&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=551142c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports